import { Helmet } from 'react-helmet'
import { AggregatorsTable } from 'components/aggregatorManagement'
import SearchBar from 'components/common/dataTable/searchBar'
import { Button } from 'components/common'
import { PlusIcon } from 'components/icons'
import { useNavigate } from 'react-router-dom'
import { PAGE_ADD_AGGREGATOR } from 'utils/constants'
import { usePageAccess } from 'hooks'

const AggregatorManagement = () => {
  const navigate = useNavigate()

  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>ORMS Aggregator Management</title>
      </Helmet>

      {/* Create Aggregator */}
      {isEditor && (
        <Button
          buttonText="Create New Aggregator"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_ADD_AGGREGATOR.path)}
        />
      )}

      <div
        className={`${
          isEditor ? 'mt-4' : ''
        } mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap`}
      >
        <h3 className="title">Current Aggregators</h3>
        <SearchBar placeholder="Search by Aggregator Name and ID" />
      </div>

      {/* Aggregator List */}
      <AggregatorsTable isEditor={isEditor} />
    </>
  )
}

export default AggregatorManagement
